module.exports = __webpack_public_path__ + "static/media/question.6c56ba11.png";